import React from "react";
import styles from "../ThreeStrip/ThreeStrip.module.css";

const ThreeStrip = () => {
  const strips = [
    {
      icon: "/Svg/Call-First.svg",
      text: "24/7 Call Handling",
      bg: "#FFF5A3",
      width: "70%",
      animationClass: styles.AnimationCall,
    },
    {
      icon: "/Svg/language-icon.svg",
      text: "32+ Language",
      bg: "#D8F3DC",
      width: "60%",
      animationClass: styles.AnimationLanguage,
    },
    {
      icon: "/Svg/Effortless-Integration.svg",
      text: "Effortless Integration",
      bg: "#BDE0FE",
      width: "80%",
      animationClass: styles.AnimationInteraction,
    },
  ];

  return (
    <div className={styles.wrapper}>
      {strips.map((item, index) => (
        <div
          key={index}
          className={styles.strip}
          style={{ backgroundColor: item.bg, width: item.width }}
        >
          <div className={`${styles.icon} ${item.animationClass}`}>
            <img src={item.icon} alt="" />
          </div>
          <p className={styles.text}>{item.text}</p>
        </div>
      ))}
    </div>
  );
};

export default ThreeStrip;
